import { SkillModel } from '../ts/interfaces/models/SkillModel';
import { BaseService } from './baseService';

class SkillService extends BaseService<SkillModel> {
  controllerName = 'skill';
}

export const skillService = new SkillService();
